
const baseURL = {
    local: 'https://testing-api.ecal.com/apiv3/',
    prod: 'https://api-cdn.ecal.com/apiv3/',  
    stage: 'https://staging-api-cdn.ecal.com/apiv3/',  
    test: 'https://testing-api.ecal.com/apiv3/',
};

export default baseURL;
